import firebase from "firebase";

// export const axios = require('axios');
import * as ApiFace from "./face";
import User from "../models/user";
import Post from "../models/post";
// import Comment from '../models/comment';

export const USER = "users";
export const STRIPE_DATA = "stripe_customers";
export const DELETED_USER = "deletedUser";
export const POST = "posts";
export const NOTIFICATION = "notifications";
export const FAV_IMAGES = "favImages";
export const BLOCKED_IMAGES = "blockedImages";

export const _remove_empty = (obj) => {
  Object.keys(obj).map((key) => {
    if (!obj[key] && obj[key] !== false) {
      delete obj[key];
    }
  });
  return obj;
};
///////////////   USER   ///////////////
export const current_uid = () => {
  return firebase.auth().currentUser ? firebase.auth().currentUser.uid : null;
};
export const sign_in_email = (email, password) => {
  return firebase.auth().signInWithEmailAndPassword(email, password);
};
export const sign_out = () => {
  firebase.auth().signOut();
};
export const get_users = async () => {
  const ref = await firebase.firestore().collection(USER).get();
  return ref.docs.map((d) => new User(d.data(), d.id));
};
export const get_user = async (key) => {
  const snapshot = await firebase.firestore().collection(USER).doc(key).get();
  if (!snapshot.exists) return null;
  return new User(snapshot.data(), key);
};
export const update_user_field = async (uid, field, value) => {
  const ref = firebase.firestore().collection(USER).doc(uid);
  const object = {};
  object[field] = value;
  console.log("update_user_field", object);
  await ref.set(object, { merge: true });
};
export const reset_user = async (uid, field = "approve", value) => {
  const ref = firebase.firestore().collection(USER).doc(uid);
  const obj = {};
  obj[field] = firebase.firestore.FieldValue.delete();
  // obj[field] = value;
  await ref.set(obj, { merge: true });
};

export const credential_mail = async (email, password) => {
  console.log(firebase.auth().EmailAuthProvider);
  await firebase.auth().currentUser.sendEmailVerification();
  // return firebase.auth().currentUser.linkWithCredential(credential);
};

///////////////   MODEL   ///////////////
export const enable_model = async (model) => {
  // const ref = firestore().collection(USER).doc(current_uid());
  // ref.set(model, {merge: true});
};
///////////////   POST   ///////////////
export const get_posts = async () => {
  const snapshot = await firebase.firestore().collection(POST).get();
  if (!snapshot.size) return null;
  return snapshot.docs.map((d) => new Post(d.data(), d.id));
};
export const get_post = async (key) => {
  const snapshot = await firebase.firestore().collection(POST).doc(key).get();
  if (!snapshot.exists) return new Post();
  return new Post(snapshot.data(), key);
};
export const update_post_field = async (id, field, value) => {
  const ref = firebase.firestore().collection(POST).doc(id);
  const object = {};
  object[field] = value;
  ref.set(object, { merge: true });
};
export const delete_post = async (key) => {
  await firebase.firestore().collection(POST).doc(key).delete();
};

///////////////   NOTIFY   ///////////////
export const create_notification = async (data) => {
  const ref = firebase.firestore().collection(NOTIFICATION).doc();
  await ref.set(data);
  return ref.id;
};

export const getNotification = async () => {
  return firebase
    .firestore()
    .collection(NOTIFICATION)
    .get()
    .then((qs) => qs.docs.map((item) => item.data()));
};

///////////////   DELETED_USERS   ///////////////
export const get_deleted_users = async () => {
  const ref = await firebase.firestore().collection(DELETED_USER).get();
  return ref.docs.map((d) => new User(d.data(), d.id));
};

export const get_deleted_user = async (key) => {
  const snapshot = await firebase
    .firestore()
    .collection(DELETED_USER)
    .doc(key)
    .get();
  if (!snapshot.exists) return null;
  return new User(snapshot.data(), key);
};

///////////////     ///////////////
export const get_user_like_images = async (uid = current_uid()) => {
  const ref = firebase.firestore().collection(`${USER}/${uid}/${FAV_IMAGES}`);
  const snapshot = await ref.get();

  return snapshot.docs.map((d) => {
    const data = d.data();
    return {
      ...data,
      result: data.result,
    };
  });
};
export const user_posts = async (uid) => {
  const ref = firebase.firestore().collection(POST);
  const snapshot = await ref.where("uid", "==", uid).get();
  return snapshot.docs.map((d) => new Post(d.data(), d.id));
};

// const getCustomerData = () => {
//   firebase.auth().onAuthStateChanged((firebaseUser) => {
//     if (firebaseUser) {
//       const currentUser = firebaseUser;
//       firebase
//         .firestore()
//         .collection("stripe_customers")
//         .doc(currentUser.uid)
//         .onSnapshot((snapshot) => {
//           if (snapshot.data()) {
//             customerData = snapshot.data();
//             startDataListeners();
//             document.getElementById("loader").style.display = "none";
//             document.getElementById("content").style.display = "block";
//           } else {
//             console.warn(
//               `No Stripe customer found in Firestore for user: ${currentUser.uid}`
//             );
//           }
//         });
//     } else {
//       document.getElementById("content").style.display = "none";
//       firebaseUI.start("#firebaseui-auth-container", firebaseUiConfig);
//     }
//   });
// };

export const get_stripe_data = async (key) => {
  const snapshot = await firebase
    .firestore()
    .collection(STRIPE_DATA)
    .doc(key)
    .get();
  if (!snapshot.exists) return null;
  return snapshot.data();
};

export const savePost = async (id, data) => {
  const ref = firebase.firestore().collection("posts").doc(id);
  await ref.set(data, { merge: true });
};
